











import { Component, Mixins } from "vue-property-decorator";
import {
  MenuPane,
} from "../../../../../base/components/panes";
import {
  EditCommandMenu,
} from "../../../../../base/components/system/edit";
import {
  ModelEditableMixin,
} from "../../../../../base/components/system/mixins";
import { FormatStructureEditableMixin } from "../mixins";
import { DomainRegistry } from "../../../../domain";

@Component({
  components: {
    MenuPane,
    EditCommandMenu,
  },
})
export default class FormatEditMenuContainer extends Mixins(ModelEditableMixin, FormatStructureEditableMixin) {
  get formatId(): number {
    return this.editingSource.getSource().id;
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  previewDocument(): void {
    const formatBean = DomainRegistry.instance.formatEditorDeveloper.getFormatService().translateFormatStructuteToSource(this.editingSource.getSource(), true);
    const editingFormat = JSON.stringify(formatBean);
    // sessionStorageは別ウィンドウだとデータを渡せないのでlocalStorageを使用
    localStorage.setItem("editingFormat", editingFormat);
    this.$openWindow(
      "/PreviewNewTemporaryDocument",
      {
        formatId: this.editingSource.getSource().id,
      }
    );
  }
}
